var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition-group',{staticClass:"error-ul",attrs:{"name":"fade","tag":"ul"}},_vm._l((_setup.errors_to_render),function(error){return _c('li',{key:error.uid,staticClass:"error-text error-li"},[_vm._v(" "+_vm._s(error.error_msg)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }